// Suspense-style wrapper around a promise: `read()` returns the value once the
// promise resolved, and otherwise throws — the pending promise (which React
// Suspense awaits) or, on failure, the error itself (which the nearest error
// boundary catches).
//
// `failed` exists so the caches in services/data.js can EVICT a wrapper whose
// read rejected. Without it a single failed read (a flaky network on one of the
// report screen's forced-server reads, say) stays in the cache for the lifetime
// of the page: every re-render reads the same wrapper, throws the same error,
// and "נסה שוב" can never recover. See services/data.test.js.
export default function wrapPromise(promise) {
  promise.throwable = promise
  promise
    .then(response =>{
      promise.done = true
      promise.timeDone = Date.now()
      promise.result = response
    })
    .catch(error => {
      promise.failed = true
      promise.throwable = error
    })

  return {
    promise,
    read() {
      if (promise.done) {
        return promise.result
      }

      throw promise.throwable
    },
  }
}
